import axios from "axios";
import { Dialog } from "antd-mobile";
import { Navigate } from 'react-router-dom'
import { ExclamationCircleFill } from 'antd-mobile-icons'

import { getStoreKey } from './auth'
import { getLoginInfo, setLoginInfo } from '../utils/storage/store'
import { getMysteryCode } from '../utils/session/store'
import { getLanguageStore } from '../utils/storage/language'
const { alert } = Dialog;

const showAlert = (content, items, msgStr) => {
  let title = 'Error'

  if (items && (items.invalidPNames || items.validProducts) && items.status) {
    title = items.status
    content = <div>
      <div>{msgStr}</div>
      <hr />
      <div>{items.invalidPNames || (items.validProducts && items.validProducts.map((item, index) => (<div className="text-gray" key={index}>{index + 1}. {item.productName}</div>)))}</div>
    </div>
  }
  alert({
    content,
    header: (
      <ExclamationCircleFill
        style={{
          fontSize: 38,
          color: 'var(--adm-color-warning)',
        }}
      />
    ),
    title
  })
}

//import store from "../store";
//import { getToken,removeToken } from './auth'

const tokenCodes = [100020, 100021, 100022, 100023, 110012, 400, 10022];

//创建一个axios示例
const service = axios.create({
  baseURL: process.env.REACT_APP_BASE_API, // api 的 base_url
  timeout: 60000, // request timeout
  headers: {
    //'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
  }
});

// 请求拦截器
service.interceptors.request.use(
  (config) => {

    const cacheData = config.cacheData ? config.cacheData.get() : null
    console.log(cacheData)
    if (cacheData) {
      return Promise.reject({ cacheData, isCache: true, config })
    } else {
      /*   
          if (store.getState().user.token) {
            // 让每个请求携带token-- ['Authorization']为自定义key 请根据实际情况自行修改
            config.headers.Authorization = getToken();
          }//*/
      const loginInfo = getLoginInfo() || {}
      const mysteryCode = getMysteryCode()
      const { user, token } = loginInfo
      if (config.method === 'post') {
        //获取登录信息
        if (user) {
          const { data: { param } } = config
          // config.data.param = { ...param, userId: user.id }
        }
      }

      if (token && token.access_token) {
        config.headers.Authorization = token.access_token
      }

      let needMysteryCode = (typeof config.needMysteryCode === 'boolean') ? config.needMysteryCode : true
      if (mysteryCode && mysteryCode !== '' && needMysteryCode) {
        config.headers['Mystery-Code'] = mysteryCode
      }

      config.params = { ...config.params, curLanguage: getLanguageStore() ,timezoneOffset: new Date().getTimezoneOffset()}


      return config;
    }


  },
  (error) => {

    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
      let hideError = false;
      const { data, status, config } = response;
      hideError = config?.hideError;
      if (data) {
        const { returnCode, returnMsg, data: items, code, msg } = data;
        if (returnCode === 0 || code === 200) {
          const nData = items || (data.hasOwnProperty('pageView') ? data.pageView : data)
          if (response && response.config && response.config.cacheData) {
            response.config.cacheData.set(nData)
          }
          return nData;
        }

        if (tokenCodes.includes(returnCode)) {//token失效
          //todo 跳到login页面
          setLoginInfo(null)
          let view = '/login'
          if (returnCode === 400) {
            const storeKey = getStoreKey()
            view = `${view}?key=${storeKey}`
          }

          console.log(window.location)

          //removeToken();
          //router.history.push(view);
          Navigate.push(view);
          //window.location.href = '/login';


          return Promise.reject(returnMsg || msg || 'error')
        }

        let msgStr = returnMsg || msg || 'network error';
        if (!(returnCode === 100 && returnMsg === 'not find customer')) {
          if (returnCode === 401) {
            msgStr = `由于您刚操作的请求耗时过长导致超时,但实际后台还在继续处理,请耐心等待后再确认您刚操作的请求是否已经完成.
            请勿重复操作.如有疑问请联系管理员.<br>
            As the request you just operated takes too long to cause the timeout, but the actual background is still processing, 
            please wait patiently to confirm that the request you just operated has completed. Do not repeat the operation. 
            If in doubt, please contact the administrator.`;
          }

          //alert('error', msgStr, [{ text: 'OK', onPress: () => console.log('ok') }])
          if (!hideError) {
            showAlert(msgStr, items, msgStr)
          }
        }

        return Promise.reject(msgStr || returnMsg || msg || 'request error')

      } else {
        return response;
      }
    } else {
      return Promise.reject('network error')
    }

  },
  (error) => {
    console.log("err" + error); // for debug

    if (error && error.isCache) {
      return Promise.resolve(error.cacheData)
    }

    let code = '';
    let hideError = false;
    if (error.response) {
      const { status, config } = error.response;
      hideError = config.hideError;
      code = status;
    } else {
      if (error.config) {
        hideError = error.config.hideError
      }

      if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1) {
        code = -404;
      }
    }

    let tips = 'api error';
    switch (code) {
      case 404:
        tips = 'api not found';
        break;
      case -404:
        tips = 'request time out';
        break;
    }

    //alert('error', tips, [{ text: 'OK', onPress: () => console.log('ok') }])
    if (!hideError) {
      showAlert(tips)
    }

    //console.log(tips)
    return Promise.reject({ status: code, tips });
  }
);

export default service;
